/**
 * 基础表格组件
 */

 import ListData from './ListData.vue'

 export default ListData


// WEBPACK FOOTER //
// ./src/components/table/index.js